import { useDataChange, useDataValue, useDataSubmit } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'board',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'update_board_status',
      board_id: id,
      status: 'active',
    })

    change(next => {
      next.selected.board_id = id
      next.selected.has_changes = false
      next.selected.board_submenu_tab_id = 'Board'
    })

    // default screen for a new board
    setFlowTo(
      normalizePath(
        props.viewPath,
        `../../../../../../../Content/Board/Content/Main/Board`
      )
    )
  }
}
